import React from 'react'
import Navbar from '../inc/Navbar'
import { Link } from "react-router-dom";
import cctvservices from "../images/camera.jpg"
import cctvpan from "../images/Pan Tilt and Zoom (PTZ) CCTV.jpg";
import Bulletcctv from "../images/Bullet CCTV.jpg";
import infreadnightcctv from "../images/Infrared Night Vision Cameras.jpg";
import wirelesscctv from "../images/WIRELESS CCTV.jpg"
import Hiddencamera from "../images/HIDDEN CAEMRA.jpg";
import PplusNVR from "../images/P PLUS 4 Channel Full HD NVR.jpg"
import ipnetworkcomboset from "../images/CP Plus 4MP IP Network Camera Combo Set.jpg"
import cctvcamera from "../images/CCTV Camera Accessories.jpg";
import cctvcameraaccessories from "../images/CCTV Camera Accessories 2.jpg";
import cctvcameraaccessorieshome from "../images/CCTV Camera Accessories 3.jpg"


function Cctv() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <div className="cctvfotageberhampore">
        <div className="album py-1">

          <div className="container mt-4">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">CCTV Camera</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      
        <div className='computershopberhampore'>
        <br />
        <div className="album py-1">

          <div className="container">
            <div className="row">
              <div className="col-md-4 mt-3" >
                <div className='card shadow'>
                  <img src={cctvpan} className="card-img-top" alt="cctv" />
                  <div className='card-body'>
                    <h5 style={{ color: "darkblue" }} className='mb-1'><b>Pan Tilt and Zoom (PTZ) CCTV</b></h5>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mt-3" >
                <div className='card shadow'>
                  <img src={Bulletcctv} className="card-img-top" alt="Bulletcctv" />
                  <div className='card-body'>
                    <h5 style={{ color: "darkblue" }} className='mb-1'><b>Bullet CCTV</b></h5>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mt-3" >
                <div className='card shadow'>
                  <img src={infreadnightcctv} className="card-img-top" alt="infreadnightcctv" />
                  <div className='card-body'>
                    <h5 style={{ color: "darkblue" }} className='mb-1'><b>Infrared Night Vision Cameras</b></h5>
                  </div>
                </div>
              </div>

              <div className="col-md-4 mt-3" >
                <div className='card shadow'>
                  <img src={wirelesscctv} className="card-img-top" alt="wirelesscctv"/>
                  <div className='card-body'>
                    <h5 style={{ color: "darkblue" }} className='mb-1'><b>Wireless CCTV</b></h5>
                  </div>
                </div>
              </div>

<div className="col-md-4 mt-3" >
                <div className='card shadow'>
                  <img src={Hiddencamera} className="card-img-top" alt="Hiddencamera"/>
                  <div className='card-body'>
                    <h5 style={{ color: "darkblue" }} className='mb-1'><b>Hidden Camera</b></h5>
                  </div>
                </div>
              </div>


<div className="col-md-4 mt-3" >
                <div className='card shadow'>
                  <img src={PplusNVR} className="card-img-top" alt="PplusNVR"/>
                  <div className='card-body'>
                    <h5 style={{ color: "darkblue" }} className='mb-1'><b>CP PLUS 4 PCS IP CAMERA SETUP</b></h5>
                  </div>
                </div>
              </div>
              

              <div className="col-md-4 mt-3" >
                <div className='card shadow'>
                  <img src={ipnetworkcomboset} className="card-img-top" alt="ipnetworkcomboset"/>
                  <div className='card-body'>
                    <h5 style={{ color: "darkblue" }} className='mb-1'><b>CP Plus 4MP IP Network Camera Combo Set</b></h5>
                  </div>
                </div>
              </div>

              <div className="col-md-4 mt-3" >
                <div className='card shadow'>
                  <img src={cctvcamera} className="card-img-top" alt="cctvcamera"/>
                  <div className='card-body'>
                    <h5 style={{ color: "darkblue" }} className='mb-1'><b>CCTV Camera Accessories</b></h5>
                  </div>
                </div>
              </div>

              <div className="col-md-4 mt-3" >
                <div className='card shadow'>
                  <img src={cctvcameraaccessories} className="card-img-top" alt="cctvcameraaccessories"/>
                  <div className='card-body'>
                    <h5 style={{ color: "darkblue" }} className='mb-1'><b>CCTV Camera Accessories</b></h5>
                  </div>
                </div>
              </div>

              <div className="col-md-4 mt-3" >
                <div className='card shadow'>
                  <img src={cctvcameraaccessorieshome} className="card-img-top" alt="cctvcameraaccessorieshome"/>
                  <div className='card-body'>
                    <h5 style={{ color: "darkblue" }} className='mb-1'><b>CCTV Camera Accessories</b></h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />

      </div>
              <br />
      <div className="album py-1">

        <div className="container ">
          <div className="row">

            <div className="col-md-8">
              <h1 style={{ color: "#030D54" }}>CCTV Camera – <b>Government Office</b></h1>
              <hr />
              <p className='justify'>Government offices require a secure, reliable, and transparent surveillance system. Our CCTV solutions ensure 24×7 monitoring, high-clarity recording, and complete activity tracking to maintain safety, control unauthorized access, and protect sensitive data. A trusted setup built for accountability, efficiency, and peace of mind.</p>
              <br />
              <h1 style={{ color: "#030D54" }}>CCTV Camera – <b>Corporate Office</b></h1>
              <hr />
              <p className='justify'>Corporate spaces demand a smart and secure environment. Our CCTV system ensures continuous monitoring, protects assets, enhances workplace safety, and maintains professional discipline. A reliable surveillance setup designed for productivity, transparency, and complete peace of mind</p>
              <br />
              <h1 style={{ color: "#030D54" }}>CCTV Camera – <b>House </b></h1>
              <hr />
              <p className='justify'>Keep your home safe with advanced CCTV surveillance designed for round-the-clock protection. Our cameras provide crystal-clear video, motion alerts, and secure remote monitoring—so you can watch over your family, property, and valuables anytime, from anywhere. A trusted security solution for complete peace of mind.</p>
              <a className='mb-3' href='tel: 9064797437'>Help Line No. 9064797437</a>
              <br />
              <br />
            </div>
            <div className="col-md-4">
              <img src={cctvservices} className="d-block w-100" alt="cctvslider" />

            </div>

          </div>

        </div>
      </div>

      <br />

    

    </div>
  )
}

export default Cctv